import request from '@/utils/request'
export function getAssetsList(page,classCid,filter) {
  classCid = '4b8798d2-91f8-4022-aa40-6ceda965fd78,982bac60-efc5-402e-b74a-789166990ed2,74ca9320-c3a4-4b0b-8b74-4c5f8b56195a,ae1b2569-b905-45a8-a2f1-0f6de5310383,71c3af89-9661-4b5a-aa1b-b213d348efc5,8801b48f-728d-4cd4-9ad2-91fdc5255484';
  return request({
    url:'api/ccas/assets-list?page='+page+'&classCid='+classCid+'&filter='+filter,
    method:'get'
  })
}
export function getAssetsListFilter(filter) {
  return request({
    url:'/api/ccas/assets-list-filter?filter='+filter,
    method:'get'
  })
}

export function CheckAssets(filter,assetsType) {
  assetsType = '4b8798d2-91f8-4022-aa40-6ceda965fd78,982bac60-efc5-402e-b74a-789166990ed2,74ca9320-c3a4-4b0b-8b74-4c5f8b56195a,ae1b2569-b905-45a8-a2f1-0f6de5310383,71c3af89-9661-4b5a-aa1b-b213d348efc5,8801b48f-728d-4cd4-9ad2-91fdc5255484';
  return request({
    url:'/api/ccas/check-assets?assetsType='+assetsType,
    method:'post',
	data:filter
  })
}

export function GetAssetsDeparts() {
  return request({
    url:'/api/ccas/get-assets-departs',
    method:'get'
  })
}

// export function ApplyScap(applyData) {
//   return request({
//     url:'api/ccas/scap-apply',
//     method:'post',
// 	data:applyData
//   })
// }
// export function ApplyTransfers(applyData) {
//   return request({
//     url:'api/ccas/transfers-apply',
//     method:'post',
// 	data:applyData
//   })
// }





